import { ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
import './AnimatedBanner.css';

const AnimatedBanner = ({ title, subtitle, buttonText, onClick, type = "primary", className = "" }) => {
  // Generate random rays for the background explosion effect
  const rays = Array.from({ length: 24 }).map((_, i) => {
    const angle = (i * 360) / 24;
    // Vary lengths and widths slightly for organic feel
    const length = 100 + Math.random() * 150;
    const width = 10 + Math.random() * 20;
    return { angle, length, width };
  });

  return (
    <div className={`animated-banner-container ${type} ${className}`}>
      <div className="banner-content-left">
        <h2 className="banner-title">{title}</h2>
        <p className="banner-subtitle">{subtitle}</p>
      </div>

      <div className="banner-visual-right">
        {/* Explosion Center */}
        <div className="explosion-center">
          {rays.map((ray, i) => (
            <motion.div
              key={i}
              className="explosion-ray"
              style={{
                width: `${ray.length}px`,
                height: `${ray.width}px`,
                transformOrigin: '0% 50%',
              }}
              animate={{
                rotate: [ray.angle, ray.angle + 360],
                // Add slight pulsing scale to some rays
                scaleX: i % 3 === 0 ? [1, 1.2, 1] : 1
              }}
              transition={{
                rotate: {
                  duration: 20 + Math.random() * 10,
                  repeat: Infinity,
                  ease: "linear"
                },
                scaleX: {
                  duration: 2 + Math.random() * 2,
                  repeat: Infinity,
                  repeatType: "reverse",
                  ease: "easeInOut"
                }
              }}
            />
          ))}
          
          <button className="banner-action-btn" onClick={onClick}>
            {buttonText} <ExternalLink size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnimatedBanner;
